/*
    Used as a drop in wrapper for interacting with diamond.
    Requires signalr library: npm install --save @aspnet/signalr

    To use:
    Copy both files from the production folder into your project
    Import the classes from diamond-api.min.js for example if using es6 modules: import {DiaMonD, CampaignArgs, QueueArgs, AgentArgs} from './diamond-api.min.js'
    Create objects for each of the endpoints you want to listen to using the classes provided
    Each array in the classes should only contain distinct values when sent to DiaMonD, you can use the provided helper method getParameterObject() to return a new object with duplicates removed from each array
    Don't make changes to any properties with a '_' prefix manually, always use the provided helper methods
*/

//import { HubConnectionBuilder } from "./signalr.min.js";
let signalR = require('@microsoft/signalr')
import axios from './axios.min.js'

export class QueueArgs {
    constructor() {
        this._QueueNumbers = []
        this._CampaignNames = []
        this._CampaignTypes = []
        this._Properties = []
    }

    static fromJSON(json) {
        return Object.assign(new QueueArgs(), json);
    }

    get QueueNumbers() {
        return this._QueueNumbers
    }

    get CampaignNames() {
        return this._CampaignNames
    }

    get CampaignTypes() {
        return this._CampaignTypes
    }

    get Properties() {
        return this._Properties
    }

    get ParameterObject() {
        let args = {}
        args.QueueNumbers = this._QueueNumbers.map(x => x.queueNum)
        args.CampaignNames = this._CampaignNames.map(x => x.campaignName)
        args.CampaignTypes = this._CampaignTypes.map(x => x.campaignType)
        args.Properties = this._Properties.map(x => x.property)
        return args
    }

    addQueueNumber(num) {
        if (typeof num === 'number') {
            var index = this._QueueNumbers.findIndex(x => x.queueNum == num)
            if (index == -1) this._QueueNumbers.push({ queueNum: num, count: 1 })
            else this._QueueNumbers[index].count += 1
        } else {
            throw "QueueArgs.addQueueNumber() - Invalid queue number provided"
        }
    }

    removeQueueNumber(num) {
        if (typeof num === 'number' && this._QueueNumbers.findIndex(x => x.queueNum == num) !== -1) {
            var index = this._QueueNumbers.findIndex(x => x.queueNum == num)
            if (this._QueueNumbers[index].count == 1) this._QueueNumbers.splice(index, 1)
            else this._QueueNumbers[index].count -= 1
        } else {
            throw "QueueArgs.removeQueueNumber() - Invalid queue number provided"
        }
    }

    addCampaignName(name) {
        if (typeof name === 'string') {
            var index = this._CampaignNames.findIndex(x => x.campaignName == name)
            if (index == -1) this._CampaignNames.push({ campaignName: name, count: 1 })
            else this._CampaignNames[index].count += 1
        } else {
            throw "QueueArgs.addCampaignName() - Invalid campaign name provided"
        }
    }

    removeCampaignName(name) {
        if (typeof name === 'string' && this._CampaignNames.findIndex(x => x.campaignName = name) !== -1) {
            var index = this._CampaignNames.findIndex(x => x.campaignName == name)
            if (this._CampaignNames[index].count == 1) this._CampaignNames.splice(index, 1)
            else this._CampaignNames[index].count -= 1
        } else {
            throw "QueueArgs.removeCampaignName() - Invalid campaign name provided"
        }
    }

    addCampaignType(typeInt) {
        if (typeof typeInt === 'number') {
            var index = this._CampaignTypes.findIndex(x => x.campaignType == typeInt)
            if (index == -1) this._CampaignTypes.push({ campaignType: typeInt, count: 1 })
            else this._CampaignTypes[index].count += 1
        } else {
            throw "QueueArgs.addCampaignType() - Invalid campaign type provided"
        }
    }

    removeCampaignType(typeInt) {
        if (typeof typeInt === 'number' && this._CampaignTypes.findIndex(x => x.campaignType = typeInt) !== -1) {
            var index = this._CampaignTypes.findIndex(x => x.campaignType == typeInt)
            if (this._CampaignTypes[index].count == 1) this._CampaignTypes.splice(index, 1)
            else this._CampaignTypes[index].count -= 1
        } else {
            throw "QueueArgs.removeCampaignType() - Invalid campaign type provided"
        }
    }

    addProperty(property) {
        if (typeof property === 'string') {
            var index = this._Properties.findIndex(x => x.property == property)
            if (index == -1) this._Properties.push({ property: property, count: 1 })
            else this._Properties[index].count += 1
        } else {
            throw "QueueArgs.addProperty() - Invalid property type provided"
        }
    }

    removeProperty(property) {
        if (typeof property === 'string' && this._Properties.findIndex(x => x.property = property) !== -1) {
            var index = this._Properties.findIndex(x => x.property == property)
            if (this._Properties[index].count == 1) this._Properties.splice(index, 1)
            else this._Properties[index].count -= 1
        } else {
            throw "QueueArgs.addProperty() - Invalid property type provided"
        }
    }
}

export class AgentArgs {
    constructor() {
        this._AgentStates = []
        this._CampaignNames = []
        this._CampaignTypes = []
        this._SecondsInState = 0
        this._Properties = []
    }

    static fromJSON(json) {
        return Object.assign(new AgentArgs(), json);
    }

    get CampaignNames() {
        return this._CampaignNames
    }

    get CampaignTypes() {
        return this._CampaignTypes
    }

    get CampaignProperties() {
        return this._Properties
    }

    get AgentNames() {
        return this._AgentNames
    }

    get AgentStates() {
        return this._AgentStates
    }

    get SecondsInState() {
        return this._SecondsInState
    }

    get ParameterObject() {
        let args = {}
        args.CampaignNames = this._CampaignNames.map(x => x.campaignName)
        args.CampaignTypes = this._CampaignTypes.map(x => x.campaignType)
        args.Properties = this._Properties.map(x => x.property)
        args.SecondsInState = this._SecondsInState
        args.AgentStates = this._AgentStates.map(x => x.agentState)
        return args
    }

    addAgentState(state) {
        if (typeof state === 'number') {
            var index = this._AgentStates.findIndex(x => x.agentState == state)
            if (index == -1) this._AgentStates.push({ agentState: state, count: 1 })
            else this._AgentStates[index].count += 1
        } else {
            throw "AgentArgs.addAgentState() - Invalid agent state provided"
        }
    }

    removeAgentState(state) {
        if (typeof state === 'number' && this._AgentStates.findIndex(x => x.agentState == state) !== -1) {
            var index = this._AgentStates.findIndex(x => x.agentState == state)
            if (this._AgentStates[index].count == 1) this._AgentStates.splice(index, 1)
            else this._AgentStates[index].count -= 1
        } else {
            throw "AgentArgs.removeAgentState() - Invalid agent state provided"
        }
    }

    addCampaignName(name) {
        if (typeof name === 'string') {
            var index = this._CampaignNames.findIndex(x => x.campaignName == name)
            if (index == -1) this._CampaignNames.push({ campaignName: name, count: 1 })
            else this._CampaignNames[index].count += 1
        } else {
            throw "AgentArgs.addCampaignName() - Invalid campaign name provided"
        }
    }

    removeCampaignName(name) {
        if (typeof name === 'string' && this._CampaignNames.findIndex(x => x.campaignName == name) !== -1) {
            var index = this._CampaignNames.findIndex(x => x.campaignName == name)
            if (this._CampaignNames[index].count == 1) this._CampaignNames.splice(index, 1)
            else this._CampaignNames[index].count -= 1
        } else {
            throw "AgentArgs.removeCampaignName() - Invalid campaign name provided"
        }
    }

    addCampaignType(typeInt) {
        if (typeof typeInt === 'number') {
            var index = this._CampaignTypes.findIndex(x => x.campaignType == typeInt)
            if (index == -1) this._CampaignTypes.push({ campaignType: typeInt, count: 1 })
            else this._CampaignTypes[index].count += 1
        } else {
            throw "AgentArgs.addCampaignType() - Invalid campaign type provided"
        }
    }

    removeCampaignType(typeInt) {
        if (typeof typeInt === 'number' && this._CampaignTypes.findIndex(x => x.campaignType == typeInt) !== -1) {
            var index = this._CampaignTypes.findIndex(x => x.campaignType == typeInt)
            if (this._CampaignTypes[index].count == 1) this._CampaignTypes.splice(index, 1)
            else this._CampaignTypes[index].count -= 1
        } else {
            throw "AgentArgs.removeCampaignType() - Invalid campaign type provided"
        }
    }

    addProperty(property) {
        if (typeof property === 'string') {
            var index = this._Properties.findIndex(x => x.property == property)
            if (index == -1) this._Properties.push({ property: property, count: 1 })
            else this._Properties[index].count += 1
        } else {
            throw "AgentArgs.addProperty() - Invalid property type provided"
        }
    }

    removeProperty(property) {
        if (typeof property === 'string' && this._Properties.findIndex(x => x.property == property) !== -1) {
            var index = this._Properties.findIndex(x => x.property == property)
            if (this._Properties[index].count == 1) this._Properties.splice(index, 1)
            else this._Properties[index].count -= 1
        } else {
            throw "AgentArgs.removeProperty() - Invalid property type provided"
        }
    }

    setSecondsInState(seconds) {
        if (typeof seconds === 'number') {
            this._SecondsInState = seconds
        } else {
            throw "AgentArgs.setSecondsInState - Invalid number of seconds provided"
        }
    }
}

export class CampaignArgs {
    constructor() {
        this._CampaignNames = []
        this._CampaignTypes = []
        this._Properties = []
    }

    static fromJSON(json) {
        return Object.assign(new CampaignArgs(), json);
    }

    get CampaignNames() {
        return this._CampaignNames
    }

    get CampaignTypes() {
        return this._CampaignTypes
    }

    get CampaignProperties() {
        return this._Properties
    }

    get ParameterObject() {
        let args = {}
        args.CampaignNames = this._CampaignNames.map(x => x.campaignName)
        args.Types = this._CampaignTypes.map(x => x.campaignType)
        args.Properties = this._Properties.map(x => x.property)
        return args
    }

    addCampaignName(name) {
        if (typeof name === 'string') {
            var index = this._CampaignNames.findIndex(x => x.campaignName == name)
            if (index == -1) this._CampaignNames.push({ campaignName: name, count: 1 })
            else this._CampaignNames[index].count += 1
        } else {
            throw "CampaignArgs.addCampaignName() - Invalid campaign name provided"
        }
    }

    removeCampaignName(name) {
        if (typeof name === 'string' && this._CampaignNames.findIndex(x => x.campaignName == name) !== -1) {
            var index = this._CampaignNames.findIndex(x => x.campaignName == name)
            if (this._CampaignNames[index].count == 1) this._CampaignNames.splice(index, 1)
            else this._CampaignNames[index].count -= 1
        } else {
            throw "CampaignArgs.removeCampaignName() - Invalid campaign name provided"
        }
    }

    addCampaignType(typeInt) {
        if (typeof typeInt === 'number') {
            var index = this._CampaignTypes.findIndex(x => x.campaignType == typeInt)
            if (index == -1) this._CampaignTypes.push({ campaignType: typeInt, count: 1 })
            else this._CampaignTypes[index].count += 1
        } else {
            throw "CampaignArgs.addCampaignType() - Invalid campaign type provided"
        }
    }

    removeCampaignType(typeInt) {
        if (typeof typeInt === 'number' && this._CampaignTypes.findIndex(x => x.campaignType == typeInt) !== -1) {
            var index = this._CampaignTypes.findIndex(x => x.campaignType == typeInt)
            if (this._CampaignTypes[index].count == 1) this._CampaignTypes.splice(index, 1)
            else this._CampaignTypes[index].count -= 1
        } else {
            throw "CampaignArgs.removeCampaignType() - Invalid campaign type provided"
        }
    }

    addProperty(property) {
        if (typeof property === 'string') {
            var index = this._Properties.findIndex(x => x.property == property)
            if (index == -1) this._Properties.push({ property: property, count: 1 })
            else this._Properties[index].count += 1
        } else {
            throw "CampaignArgs.addProperty() - Invalid property type provided"
        }
    }

    removeProperty(property) {
        if (typeof property === 'string' && this._Properties.findIndex(x => x.property == property) !== -1) {
            var index = this._Properties.findIndex(x => x.property == property)
            if (this._Properties[index].count == 1) this._Properties.splice(index, 1)
            else this._Properties[index].count -= 1
        } else {
            throw "CampaignArgs.removeProperty() - Invalid property type provided"
        }
    }
}

export const Constants = {
    MonitoringState: {
        NotMonitoring: 0,
        Monitoring: 1,
        Connected: 3,
        NotConnected: 4
    },
    MonitoringAgentState: {
        LoggedOut: 0,
        LoggedIn: 1
    },
    AgentStates: [
        { name: "Not Logged In", value: 0 },
        { name: "Awaiting Login", value: 1 },
        { name: "Unavailable", value: 2 },
        { name: "Waiting For Call", value: 3 },
        { name: "Previewing", value: 4 },
        { name: "Breather", value: 5 },
        { name: "Talking", value: 6 },
        { name: "In Wrap", value: 7 },
        { name: "Waiting for specific call", value: 8 },
        { name: "Dialling Manual Call", value: 9 },
        { name: "Offering Transfer", value: 10 },
        { name: "Waiting To Transfer", value: 11 },
        { name: "Being Offered Transfer", value: 12 },
        { name: "Dialling Preview", value: 15 },
        { name: "Previewing Offline Message", value: 16 },
        { name: "Processing Offline Message", value: 17 },
    ],
    DiamondUrls: {
        0: "https://newdiamond.geniusppt.com",
        1: "https://newdiamond.geniusppt.ie",
        2: "https://newdiamondcso.geniusppt.ie",
        4: "https://newdiamond-canada.geniusppt.com",
        5 : "https://diamond.geniusssl.com"
    }
}

export default class DiaMonD {
    isRequired(paramName, methodName) { throw new Error(`Parameter ${paramName} is required for ${methodName}()`) }

    constructor(identity = this.isRequired("identity", "DiaMonD"), token, site = 0) {
        this._site = site
        if (token) {
            this._token = token;
            localStorage.token = token
        } else console.log("No authentication token provided, connection will be made but needs to be authenticated before data will be provided.")

        this._serverTimeOffset = 0

        const axiosConf = {
            baseURL: this.diamondRestUrl,
        };

        this.$http = axios.create(axiosConf);
        this._identity = identity;

        this.$http.interceptors.request.use(
            (config) => {
                if (localStorage.token) config.headers["token"] = `${localStorage.token}`;
                return config;
            },
            (error) => Promise.reject(error)
        );
        this.setupConnection()
    }

    setupConnection() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.diamondUrl)
            .configureLogging(process.env.NODE_ENV === 'production' ? signalR.LogLevel.None : signalR.LogLevel.Information) //Disables all console logging in live code
            .withAutomaticReconnect()
            .build()

        this.connection.on("Authorized", (msg) => {
            this.authorized(msg)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("ReceiveError", (msg) => {
            this.defaultErrorHandler(msg)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("SendCon", (conn) => {
            this.receiveConnectionId(conn)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("UpdateMonitorAgentState", (msg) => {
            this.monitorStateChange(msg)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("SystemTime", (msg) => {
            if(!msg) return;
            this._serverTimeOffset = Date.now() - (new Date(Date.parse(msg))).getTime()
        })

        this.connection.onreconnecting(() => {
            if (this.connection.baseUrl !== this.diamondUrl) {
                this.restartConnection()
            }
        })

        this.connection.on("InvalidSession", () => {
            localStorage.removeItem("token")
            this.restartConnection()
        })

        this.connection.onreconnected(() => {
            var ev = new CustomEvent("reconnected")
            this._lastReconnect = Date.now();
            window.dispatchEvent(ev)
        })
    }

    restartConnection() {
        this.connection.stop()
        this.setupConnection();
    }

    //Manually invokes a method within diamond
    invoke(x, ...args) {
        this.connection.invoke(x, ...args)
    }

    //Sends initial campaign parameters object, needs to be called at least once to start receiving broadcasts
    sendCampaignParameters(args = this.isRequired("args", "sendCampaignParameters")) {
        if (args instanceof CampaignArgs) {
            sessionStorage.setItem("campaignArgs", args)
            this.invoke("CampaignInfo", args.ParameterObject)
        } else {
            throw "DiaMonD.sendCampaignParameters() - parameter must be of the provided ArgsObject type, did you forget to use ParameterObject?"
        }
    }

    //Sends initial queue parameters object, needs to be called at least once to start receiving broadcasts
    sendQueueParameters(args = this.isRequired("args", "sendQueueParameters")) {
        if (args instanceof QueueArgs) {
            sessionStorage.setItem("queueArgs", args)
            this.invoke("QueueInfo", args.ParameterObject)
        } else {
            throw "DiaMonD.sendQueueParameters() - parameter must be of the provided ArgsObject type, did you forget to use ParameterObject?"
        }
    }

    //Sends initial agent parameters object, needs to be called at least once to start receiving broadcasts
    sendAgentParameters(args = this.isRequired("args", "sendAgentParameters")) {
        if (args instanceof AgentArgs) {
            sessionStorage.setItem("agentArgs", args)
            this.invoke("AgentInfo", args.ParameterObject)
        } else {
            throw "DiaMonD.sendAgentParameters() - parameter must be of the provided ArgsObject type, did you forget to use ParameterObject?"
        }
    }

    //Starts the signalR connection
    start() {
        this.startedPromise = this.connection.start().then(() => {
            this.onConnected()
        })
            .catch(() => {
                return new Promise((resolve, reject) =>
                    setTimeout(() =>
                        this.start().then(resolve).catch(reject),
                        5000
                    )
                )
            })

        return this.startedPromise
    }

    GetOpenConnection() {
        return new Promise((resolve, reject) => {
            const msMax = 100000;
            const msInc = 10;
            var ms = 0;
            var idInterval = setInterval(() => {
            //    console.log("connected: " + this.isConnected);
                if (this.isConnected || this.connection.state == signalR.HubConnectionState.Connected) {
                    clearInterval(idInterval);
                    resolve();
                }
                ms += msInc;
                if (ms >= msMax) {
                    clearInterval(idInterval);
                    reject();
                }
            }, msInc);
        });
    }

    onConnected() {
      //  console.log("onConnected");
        var campaignArgs = sessionStorage.getItem('campaignArgs')
        var queueArgs = sessionStorage.getItem('queueArgs')
        var agentArgs = sessionStorage.getItem('agentArgs')

        if (campaignArgs.ParameterObject) this.sendCampaignParameters(campaignArgs)
        if (queueArgs.ParameterObject) this.sendQueueParameters(queueArgs)
        if (agentArgs.ParameterObject) this.sendAgentParameters(agentArgs)
    }

    get diamondUrl() {
        var url = `${this.useLiveUrl ? Constants.DiamondUrls[this._site] : `http://localhost:6060`}/DiaMonD`;
        if (localStorage.token) url = `${url}?token=${localStorage.token}`
        return url
    }

    get diamondRestUrl() {
        return `${this.useLiveUrl ? Constants.DiamondUrls[this._site] : `http://localhost:6060`}/api/diamond`;
    }

    get useLiveUrl() {
        return process.env.NODE_ENV === 'production' || window.usingLiveApi
    }

    get identity() {
        return this._identity;
    }

    //Returns the current connection state of the signalR hub
    get isConnected() {
        return this.connection.connectionState === "Connected"
    }

    get connectionId() {
        return this._connectionId
    }

    get isAuthorized() {
        var res = this._authorized;
        return this._authReceived ? res : null
    }

    get allowedCampaigns() {
        return this._campaignList
    }

    get allowedQueues() {
        return this._queuesList
    }

    get campaignPropertiesAndTypes() {
        return this._campaignProperties
    }

    get queuePropertiesAndTypes() {
        return this._queueProperties
    }

    get agentPropertiesAndTypes() {
        return this._agentProperties
    }

    get sessionId() {
        return this._sessionId
    }

    get latestError() {
        return this._error;
    }

    get breakReasons() {
        return this._breakReasons;
    }

    get monitorAgentState() {
        return this._monitorAgentState;
    }

    get lastMessageStamp() {
        return this._lastMessageStamp;
    }

    get lastReconnect() {
        return this._lastReconnect;
    }

    get site(){
        return this._site
    }

    setDefaultLayout(layoutId = this.isRequired("layoutId", "setDefaultLayout")) {
        if (typeof layoutId === 'number') {
            return new Promise((resolve, reject) => {
                this.$http.post(`SetDefaultLayout?layoutId=${layoutId}&identity=${this.identity}`).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            })
        }
        else {
            throw "DiaMonD.setDefaultLayout() - Invalid parameter types provided"
        }
    }

    //Registers the methods to be ran when broadcasts are received
    attachListeners(campaignListener, queueListener, agentListener) {
        this.connection.on("CampaignInfoReceived", (message) => {
            campaignListener(message)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("QueueInfoReceived", (message) => {
            queueListener(message)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("AgentInfoReceived", (message) => {
            agentListener(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachUpdateListeners(campaignUpdate, queueUpdate, agentUpdate) {
        this.connection.on("CampaignUpdateReceived", (message) => {
            campaignUpdate(message)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("QueueUpdateReceived", (message) => {
            queueUpdate(message)
            this._lastMessageStamp = Date.now();
        })

        this.connection.on("AgentUpdateReceived", (message) => {
            agentUpdate(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachCampaignListener(campaignListener) {
        this.connection.on("CampaignInfoReceived", (message) => {
            campaignListener(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachQueueListener(queueListener) {
        this.connection.on("QueueInfoReceived", (message) => {
            queueListener(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachAgentListener(agentListener) {
        this.connection.on("AgentInfoReceived", (message) => {
            agentListener(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachAgentUpdate(agentUpdate) {
        this.connection.on("AgentUpdateReceived", (message) => {
            agentUpdate(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachQueueUpdate(queueUpdate) {
        this.connection.on("QueueUpdateReceived", (message) => {
            queueUpdate(message)
            this._lastMessageStamp = Date.now();
        })
    }

    attachCampaignUpdate(campaignUpdate) {
        this.connection.on("CampaignUpdateReceived", (message) => {
            campaignUpdate(message)
            this._lastMessageStamp = Date.now();
        })
    }

    authorized(msg) {
        if (!msg) this._authorized = false
        else this._authorized = true

        this._authReceived = true
        this._sessionId = msg
    }

    monitorStateChange(newState) {
        this._monitorAgentState = newState;
        var ev = new CustomEvent("agentStateChange", {
            detail: {
                state: this._monitorAgentState
            }
        })
        window.dispatchEvent(ev)
    }

    attachErrorHandler(errorHandler) {
        this.connection.on("ReceiveError", (message) => {
            errorHandler(message)
            this._lastMessageStamp = Date.now();
        })
    }

    receiveConnectionId(conn) {
        this._connectionId = conn
    }

    defaultErrorHandler(msg) {
        this._error = msg
    }

    authenticate(username = this.isRequired("username", "authenticate"), password = this.isRequired("password", "authenticate")) {
        if (typeof username === 'string' && typeof password === 'string') {
            return new Promise((resolve, reject) => {
                this.$http.post(`Authenticate?username=${username}&password=${password}&connId=${this.connectionId}`).then(res => {
                    localStorage.token = res.data.token;
                    resolve(res);
                }).catch(err => reject(err));
            })
        }
        else {
            throw "DiaMonD.authenticate() - Invalid parameter types provided"
        }
    }

    confirm2fa(token = this.isRequired("token", "confirm2fa"), code = this.isRequired("code", "confirm2fa")) {
        if (typeof token === 'string' && typeof code === 'string') {
            return new Promise((resolve, reject) => {
                this.$http.post(`2fa?token=${token}&code=${code}&connId=${this.connectionId}`).then(res => {
                    localStorage.token = res.data.token
                    resolve(res)
                }).catch(err => reject(err));
            });
        }
        else {
            throw "DiaMonD.confirm2fa() - Invalid parameter types provided"
        }
    }

    selectTenant(tenant = this.isRequired("tenant", "selectTenant")) {
        if (typeof tenant === 'string') {
            return new Promise((resolve, reject) => {
                this.$http.post(`SelectTenant?tenant=${tenant}`).then((res) => {
                    localStorage.token = res.data.token;
                    resolve();
                }).catch(() => reject());
            })
        } else {
            throw "DiaMonD.selectTenant() - Invalid parameter types provided"
        }
    }

    getDashboardLayout(id = this.isRequired("id", "getDashboardLayout")) {
        if (typeof id === 'number') {
            return new Promise((resolve, reject) => {
                var url = `LoadLayout/${id}`
                if (this.identity) url += `?identity=${this.identity}`

                this.$http.get(url).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            })
        } else {
            throw "DiaMonD.getDashboardLayout(id) - Provided incorrect parameter type"
        }
    }

    deleteLayout(id = this.isRequired("id", "deleteLayout")) {
        if (typeof id === 'number') {
            return new Promise((resolve, reject) => {
                this.$http.post(`delete/${id}`).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        } else {
            throw "DiaMonD.deleteLayout(id) - Provided incorrect parameter type"
        }
    }

    kickAgent(agentName = this.isRequired("agentName", "kickAgent")) {
        if (typeof agentName === 'string') {
            return new Promise((resolve, reject) => {
                this.$http.get(`kick/${agentName}`).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        } else {
            throw "DiaMonD.kickAgent(agentName) - Provided incorrect parameter type"
        }
    }

    setCampaignState(campaignName = this.isRequired("campaignName", "setCampaignState"), state = this.isRequired("state", "setCampaignState")) {
        if (typeof campaignName === 'string' && typeof state === 'string') {
            return new Promise((resolve, reject) => {
                this.$http.get(`campaignstate/${campaignName}/${state}`).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        } else {
            throw "DiaMonD.setCampaignState(campaignName, state) - Provided incorrect parameter type"
        }
    }


    connectListener(extension = this.isRequired("extension", "connectListener"), campaign = this.isRequired("campaign", "connectListener"), coachAgent = this.isRequired("coachAgent", "connectListener")) {
        return new Promise((resolve, reject) => {
            this.$http.get(`ConnectListener?phone=${extension}&campaign=${campaign}&coachAgent=${coachAgent}`).then((res) => {
                resolve(res);
            }).catch((err) => reject(err));
        })
    }

    listenToAgent(agent = this.isRequired("agent", "listenToAgent")) {
        return new Promise((resolve, reject) => {
            this.$http.get(`StartListening?agent=${agent}`).then((res) => {
                resolve(res);
            }).catch((err) => reject(err));
        })
    }

    cancelListener() {
        return new Promise((resolve, reject) => {
            this.$http.get(`CancelListening`).then((res) => {
                resolve(res);
            }).catch((err) => reject(err));
        })
    }

    getDashboardLayouts() {
        return new Promise((resolve, reject) => {
            this.$http.get(`ListLayouts`).then((res) => {
                resolve(res);
            }).catch((err) => reject(err));
        })
    }

    createLayout(name = this.isRequired("name", "saveLayout"), data = this.isRequired("data", "saveLayout")) {
        return this.saveLayout(-1, name, data)
    }

    saveLayout(id = this.isRequired("id", "saveLayout"), name = this.isRequired("name", "saveLayout"), data = this.isRequired("data", "saveLayout")) {
        return new Promise((resolve, reject) => {
            this.$http.post(`SaveLayout?id=${id}&name=${name}`, { Data: data }).then((res) => {
                resolve(res);
            }).catch((err) => reject(err));
        })
    }

    getSite() {
        return new Promise((resolve, reject) => {
            this.$http.get(`getSite`).then((res) => {
                resolve(res);
            }).catch((err) => reject(err));
        })
    }

    async getData() {
        return new Promise((resolve, reject) => {
            axios.all([
                this.$http.get(`AllowedCampaigns`),
                this.$http.get(`AllowedQueues`),
                this.$http.get(`CampaignProperties`),
                this.$http.get(`QueueProperties`),
                this.$http.get(`AgentProperties`),
                this.$http.get(`BreakReasons`)
            ]
            ).then(axios.spread((campaigns, queues, campaignProps, queueProps, agentProps, breakReasons) => {
                this._campaignList = campaigns.data
                this._queuesList = queues.data
                this._campaignProperties = campaignProps.data
                this._queueProperties = queueProps.data
                this._agentProperties = agentProps.data
                this._breakReasons = breakReasons.data
                resolve();
            })).catch((err) => {
                console.log(`Error getting data ${err}`);
                reject(err)
            }
            );
        })
    }
}